import { useIntl } from 'react-intl';

export const useDisplayText = () => {
  const { formatMessage } = useIntl();

  return {
    pickupDetailsHeading: formatMessage({ id: 'pickupDetailsHeading' }),
    pickupDetailsSubheading: formatMessage({ id: 'pickupDetailsSubheading' }),
    backButton: formatMessage({ id: 'pickupDetailsBackButton' }),
    continueButton: formatMessage({ id: 'pickupDetailsNextButton' }),
  };
};
